/* unplugin-vue-components disabled */import { render } from "./NotificationIcon.vue?vue&type=template&id=14538bd3&scoped=true&ts=true"
import script from "./NotificationIcon.vue?vue&type=script&lang=ts"
export * from "./NotificationIcon.vue?vue&type=script&lang=ts"

import "./NotificationIcon.vue?vue&type=style&index=0&id=14538bd3&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14538bd3"]])

export default __exports__